export enum RtcSessionTerminateCauses {
  LEAVE_TEAMING = 'LeaveTeaming',
  HANDOFF = 'Handoff',
  ADMIN_CANCELED_CALL = 'AdminCanceledCall',
  RETURN_TO_QUEUE = 'ReturnToQueue',
  REFER = 'Refer',
  UNEXPECTED_LEAVE_TERMINATION = 'UnexpectedLeaveTermination',
}
